import { Skeleton, styled } from '@mui/material'
import { TAG_SIZE_VALUES, TAG_SIZE } from '../../Tag/constants'

export const BadgeSkeleton = styled(Skeleton)`
  width: ${({ theme }) => theme.spacing(7)};
  height: ${({ theme }) => theme.spacing(TAG_SIZE_VALUES[TAG_SIZE.large])};
`

export const HeaderContainer = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const BodyContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(3)};
`

export const BodyLabel = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'width',
})<{ width?: number }>`
  width: ${({ theme, width }) => theme.spacing(width ?? 10)};
  height: ${({ theme }) => theme.spacing(3)};
`

export const TitleLabel = styled(Skeleton)`
  width: ${({ theme }) => theme.spacing(20)};
  height: ${({ theme }) => theme.spacing(3)};
`
